import Paginate from 'vuejs-paginate'
import Status from '@/components/status-user'
export default {
  name: 'list-users',
  components: {Paginate, Status},
  props: ['organization'],
  data () {
    return {
      per_page: 20,
      status: '',
      organization_id: null,
      search: '',
      group: '',
      loading: false,
      open_search: false,
      page: 0
    }
  },
  computed: {
    can_getUser () {
      var permission = this.$store.getters['Profile/getPermission']
      var groupId = this.$store.getters['Profile/getGroup']
      return permission.indexOf(this.$permissions.VIEW_USER_ORGANIZATION) !== -1 || groupId === 1
    },
    show () {
      return this.$store.getters['Organization/getOpenUser']
    },
    users () {
      return this.$store.getters['User/users']
    },
    last_page () {
      return this.$store.getters['User/last_page']
    },
    total () {
      return this.$store.getters['User/total']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    options () {
      return this.$store.getters['Status/getStatusUser']
    },
    groups () {
      return this.$store.getters['Group/getListGroup']
    }
  },
  mounted () {
    // if (!this.can_getUser) {
    //   return false
    // }
    // this.loading = true
    // Promise.all([
    //   this.initData(),
    //   this.$store.dispatch('Group/getListGroup', {page: 1, per_page: 'all'})
    // ]).then(res => {
    //   this.loading = false
    // }).catch(errors => {
    //   this.loading = false
    // })
  },
  watch: {
    // organization: function () {
    //   if (!this.can_getUser) {
    //     return false
    //   }
    //   this.loading = true
    //   Promise.all([
    //     this.initData()
    //   ]).then(res => {
    //     this.loading = false
    //   }).catch(errors => {
    //     this.loading = false
    //   })
    // }
  },
  methods: {
    btn_search () {
      this.open_search = !this.open_search
    },
    filter () {
    
      this.initData().then(res => {
        
      }).catch(errors => {
        
      })
    },
    changeTotal () {
    
      this.initData().then(res => {
        
      }).catch(errors => {
        
      })
    },
    changePage (pageNum) {
      this.page = pageNum
    },
    initData () {
      return this.$store.dispatch('User/getData', { page: this.page, per_page: this.per_page, search: this.search, sort: this.sort, status: this.status, group_id: this.group, organization_id: this.organization.id })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/organization/list-users/list-users.js